import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useApp } from "../context/AppContext";
import { BrandLogo } from "../components/BrandLogo";

const AuthCallback = () => {
    const navigate = useNavigate();
    const { setUser } = useApp();
    const processed = useRef(false);

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;

        const hash = window.location.hash || "";
        const match = hash.match(/session_id=([^&]+)/);
        if (!match) {
            navigate("/?auth_error=1");
            return;
        }
        const session_id = match[1];

        (async () => {
            try {
                const res = await api.post("/auth/session", { session_id });
                setUser(res.data.user);

                // Push the user's local language/theme preference to the server so it persists
                const localLang = localStorage.getItem("vlg_lang");
                const localTheme = localStorage.getItem("vlg_theme");
                const partial = {};
                if (localLang && res.data.user.language !== localLang) partial.language = localLang;
                if (localTheme && res.data.user.theme !== localTheme) partial.theme = localTheme;
                if (Object.keys(partial).length > 0) {
                    try {
                        const updated = await api.patch("/auth/settings", partial);
                        setUser(updated.data);
                    } catch (e) {
                        console.warn("AuthCallback: settings sync failed", e);
                    }
                }

                window.history.replaceState({}, "", "/dashboard");
                // Signal Dashboard to celebrate with confetti on arrival
                try { window.sessionStorage.setItem("vlg_just_logged_in", "1"); } catch (e) {}
                navigate("/dashboard", { state: { user: res.data.user } });
            } catch (e) {
                navigate("/?auth_error=1");
            }
        })();
    }, [navigate, setUser]);

    return (
        <div className="min-h-screen grid place-items-center bg-[hsl(var(--background))]">
            <div className="flex items-center gap-3 text-[hsl(var(--primary))]">
                <BrandLogo size={36} />
                <div className="font-display font-bold text-xl">Vive a lo Grande</div>
            </div>
        </div>
    );
};

export default AuthCallback;
